export const getFontSize = (place: number) => {
	if (place < 10) return "1.75rem"
	if (place < 100) return "1.65rem"
	if (place < 1000) return "1.55rem"
	if (place < 10000) return "1.45rem"

	return "1.75rem"
}
